<template>
	<SOSlotModal
		:modal-id="pageSetting.modalId"
		:modal-title="pageSetting.modalTitle"
		@close="close"
	>
		<template v-slot:modal-body>
			<SOInputTextarea
				:placeholder="'Keterangan'"
				:title="'Keterangan'"
				:id="'keterangan'"
				:validation="'alphanumeric'"
				:value="rekeningBankDetail.keterangan"
				v-model="keterangan"
				@input="(val) => { keterangan = val }"
			/>
		</template>

		<template v-slot:modal-footer>
			<SOButton
				:text="'Simpan'"
				:primary="true"
				:full="true"
				:disable="pageSetting.btn.save.disabled"
				:loading="pageSetting.btn.save.loading"
				@action="edit"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputTextarea from "@/so-components/global/input/SOInputTextarea";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "RekeningBankModalKeteranganRekening",
	components: {
		SOSlotModal,
		SOInputTextarea,
		SOButton,
	},
	computed: {
		...mapGetters("rekeningBankModule", {
			rekeningBankDetail: "getRekeningBankDetail",
		}),
	},
	data() {
		return {
			pageSetting: {
				modalTitle: "Ubah keterangan",
				modalId: "modal-rekening-bank-ubah-nama-rekening",
				btn: {
					save: {
						loading: false,
						disabled: false,
					}
				},
			},
			keterangan: "",
		}
	},
	mounted() {
		$("#" + this.pageSetting.modalId).modal("show");
		this.keterangan = this.rekeningBankDetail.keterangan
	},
	methods: {
		close() {
			$("#" + this.pageSetting.modalId).modal("hide");
			setTimeout(() => {
				this.$router.back()
			}, 300)
		},
		async edit() {
			this.pageSetting.btn.save.loading = true
			this.pageSetting.btn.save.disabled = true
			let form = new FormData
			form.append("idakun_keuangan", this.rekeningBankDetail.idakun_keuangan)
			form.append("nama_rekening", this.rekeningBankDetail.nama)
			form.append("nama_pemilik", this.rekeningBankDetail.pemilik_rekening)
			form.append("nomor_rekening", this.rekeningBankDetail.nomor_rekening)
			form.append("keterangan", this.keterangan)
			const res = await this.$store.dispatch("rekeningBankModule/fetchRekeningBankUpdate", {
				jenis: "keterangan",
				form: form,
			})
			this.pageSetting.btn.save.loading = false
			this.pageSetting.btn.save.disabled = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.$toast.success(res.msg)
			this.rekeningBankDetail.keterangan = this.keterangan
			await this.$store.commit("rekeningBankModule/resetRekeningBank")
			this.close()
		}
	}
}
</script>